import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { Banner } from "../../shared/models/banner";
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";

import { MatExpansionModule } from "@angular/material/expansion";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";




@Component({
    selector: "div.dtf-newPrivacypage",
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatNativeDateModule,
        MatDatepickerModule, MatIconModule, MatExpansionModule, MatSortModule
    ],
    templateUrl: './newPrivacy.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class NewPrivacyComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  isFrench = false;
  targetRedirect = '';
  localRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  azURL: string;
  baseRedirect = '';
  countryFlag: string;
  langFlag: string;
  bodyLoaded = false;
  accountRedirect = '';
  token: string;
  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    //this.getAlerts();
    this.langInit();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    const usePrivacy = (window as any).mbfs.usePrivacy;
    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.localRedirect = this.usUrl + '/ca/en/';
    } else if (this.language === 'fr-CA') {
        this.localRedirect = this.usUrl + '/ca/fr/';

    } else {
        this.localRedirect = this.usUrl;
    }
  }
  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL =  this.accountRedirect + '?blink=' + redirect;
      if(this.langFlag === 'fr-CA'){
         
           if (redirect === 'newPrivacy'){
            this.azURL =  this.usUrl + '/ca/fr/home/newPrivacy';
          }
          else if (redirect ==='ccpa'){
            this.azURL =  this.usUrl + '/ca/fr/home/ccpa';
          }
         
      }
      else{
        if (redirect === 'newPrivacy'){
          this.azURL =  this.usUrl + '/ca/en/home/newPrivacy';
        }
        else if (redirect ==='ccpa'){
          this.azURL =  this.usUrl + '/ca/en/home/ccpa';
        }
      }
    }
  
}


}
